import { type ComponentProps } from 'react';

import { cn } from '@/utils/cn';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

function Checkbox({ className, ref, ...props }: ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-solid shadow-xs transition-shadow outline-none',
        'border-neutral-300 bg-white',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:border-error-500 aria-invalid:ring-error-500/20',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:border-neutral-950 data-[state=checked]:bg-neutral-950 data-[state=checked]:text-white',
        'data-[state=indeterminate]:border-neutral-950 data-[state=indeterminate]:bg-neutral-950 data-[state=indeterminate]:text-white',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className={cn('flex items-center justify-center text-current')}
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
